import React, { Fragment } from 'react';
import TextSubMenu from '../TextSubMenu';
export const SubMenuSection = ({ items, clickCallback }) => {
    if (!items)
        return null;
    return (React.createElement(React.Fragment, null, items.map((item) => item ? (React.createElement(Fragment, { key: item.id },
        React.createElement(TextSubMenu, { item: item, clickCallback: clickCallback }))) : null)));
};
//# sourceMappingURL=index.js.map